import React, { useEffect, useState } from 'react';
import './../modal/modal.scss';
import CustomInput from '../inputs/new-input';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { formatTaskData } from './formatters/task';
import { formatSubTaskData } from './formatters/subtask';
import { formatProjectData } from './formatters/project';
import { useDispatch,useSelector } from 'react-redux';
import { addItemTemplate, addTaskTemplate, getExistingItemTemplate, editItemTemplate } from '../../actions/template-management.action';
import { listTemplateCategories } from "../../actions/inventory.action";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@material-ui/core";
import TemplateCategory from '../../routes/templates/category.jsx';
import DuplicateTemplateDialog from '../duplicate-template-dialog';

function SaveTemplate({ open, data = {}, type, dialogClose }) {
  const [newItem, setNewItem] = useState({
    name: '',
    material: [],
    labor: [],
    subcontractor: []
  });
  const [category, setCategory] = useState(null);
  const [categoryName, setCategoryName] = useState('');
  const [error, setError] = useState('');
  const [duplicateDialog, setDuplicateDialog] = useState({
    open: false,
    templateName: '',
    existingTemplateId: '',
    canProceed: false,
    itemsEqual: false
  });
  const categoryList = useSelector(state => state.category.categories) || [];
  const [openCategoryDialog, setOpenCategoryDialog] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (categoryList.length === 0) dispatch(listTemplateCategories()).catch(e => console.log(e))
  }, []);

  useEffect(() => {
    if (!newItem.name) {
      setNewItem({
        name: data.name || data.description,
        material: data.material || [],
        labor: data.labor || [],
        subcontractor: data.subcontractor || []
      });
    }
  }, [data, type]);
  const openCategoryPopup = () => {
    setOpenCategoryDialog(true);
  };


  const saveHandler = () => {
    if (!newItem.name) {
      setError('Please fill the name to save the template');
      return;
    }
    if (type === 'subtask' && !category) {
      setError('Please select a category');
      return;
    }

    if (type === 'subtask') {
      // Check for duplicate template name
      dispatch(getExistingItemTemplate(newItem))
        .then((existingTemplate) => {
          if (existingTemplate !== null && existingTemplate.matchingTask.id) {
            // Show duplicate dialog
            setDuplicateDialog({
              open: true,
              templateName: newItem.name,
              existingTemplateId: existingTemplate.matchingTask.id,
              canProceed: existingTemplate.canProceed,
              itemsEqual: existingTemplate.itemsEqual
            });
          } else {
            if(existingTemplate.canProceed) {
              // No duplicate, proceed with save
              saveItemTemplate();
            } else {
              // Show duplicate dialog
              setDuplicateDialog({
                open: true,
                templateName: newItem.name,
                existingTemplateId: existingTemplate.matchingTask.id,
                canProceed: existingTemplate.canProceed,
                itemsEqual: existingTemplate.itemsEqual
              })
            }
          }
        })
        .catch(error => {
          console.error("Error checking existing template:", error);
          // In case of error, still try to save
          saveItemTemplate();
        });
    } else {
      // Handle other template types
      saveNonItemTemplate();
    }
  };

  const saveItemTemplate = () => {
    let categoryId = category?.value;
    const req = formatSubTaskData({data, name: newItem.name, categoryId});
    dispatch(addItemTemplate(req))
      .then(() => {
          dispatch(listTemplateCategories())
          .catch(error => {
             console.error("Error listing template categories:", error);
          })
          .finally(() => {
             closeDialog();
          });
      })
      .catch(error => {
        console.error("Error adding item template:", error);
      });
  };
  
  const saveNonItemTemplate = () => {
    let req = {};
    switch (type) {
      case 'project':
        req = formatProjectData(data, newItem.name);
        break;
      case 'task':
        req = formatTaskData(data, newItem.name);
        dispatch(addTaskTemplate(req))
          .then(() => {
            closeDialog();
          })
          .catch(console.error);
        break;
      default:
        console.warn("Unsupported template type:", type);
        closeDialog();
    }
  };

  const updateExistingTemplate = () => {
    let categoryId = category?.value;
    const req = formatSubTaskData({data, name: newItem.name, categoryId});
    
    dispatch(editItemTemplate(duplicateDialog.existingTemplateId, req))
      .then(() => {
        // Close both dialogs
        setDuplicateDialog({ open: false, templateName: '', existingTemplateId: '' });
        closeDialog();
      })
      .catch(error => {
        console.error("Error updating existing template:", error);
      });
  };

  const closeDuplicateDialog = () => {
    setDuplicateDialog({ open: false, templateName: '', existingTemplateId: '' });
  };

  const closeDialog = () => {
    setNewItem({
      name: '',
      material: [],
      labor: [],
      subcontractor: []
    });
    setCategory(null);
    setCategoryName('');
    setError('');
    if (dialogClose) dialogClose();
  };
  const handleCategoryInputChange = (event, newValue) => {
    if (!categoryList.some(cat => cat.key.toLowerCase() === newValue.toLowerCase())) {
      setCategory(null);
    }
    setCategoryName(newValue);
  };
  useEffect(() => {
    if (categoryName) {
      const newCategory = categoryList.find(cat => cat.name.toLowerCase() === categoryName.toLowerCase());
      if (newCategory) {
        setCategory(newCategory);
      }

    }
  }, [categoryList]);
  return (
    <>
      {openCategoryDialog && (
        <TemplateCategory
          open={openCategoryDialog}
          showList={false}
          type={'subtask'}
          defaultCategoryName={categoryName}
          dialogClose={(savedCategory) => {
            setOpenCategoryDialog(false);
            if (savedCategory) {
              setCategory({
                id: savedCategory.id,
                key: savedCategory.name,
              });
              setCategoryName(savedCategory.name);
            }
          }}
        />
      )}


      <Modal
        show={open}
        onHide={closeDialog}
        dialogClassName="modal-70w create-modal"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {type === 'task' ? 'Save as Task Template' :
              type === 'subtask' ? 'Save as Item Template' :
                type === 'project' ? 'Save as Project Template' : 'Save Template'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 mt-3">
              <CustomInput
                type="text"
                label="Template Name"
                value={newItem.name}
                onChange={(e) => setNewItem({...newItem, name: e.target.value})}
                required={true}
                error={error}
              />
            </div>


            {type === 'subtask' && (
              <div className="col-12 mt-3">
                <Autocomplete
                  value={categoryList.find(cat => cat.value === category?.value) || null}
                  onChange={(event, newValue) => {
                    if (newValue?.isAddOption) {
                      setCategory(null);
                      setCategoryName('');
                      openCategoryPopup();
                    } else {
                      setCategory(newValue);
                    }
                  }}
                  options={categoryList}
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option) => {
                    if (option.isAddOption) {
                      return (
                        <li
                          {...props}
                          key="add-option"
                          onClick={openCategoryPopup}
                          className="fs-6 fw-bold text-left sync-icon ms-0 ms-3 py-1"
                        >
                          {categoryName && categoryName.toString().trim() ? `Add "${categoryName}"` : "Add Category"}
                        </li>
                      );
                    }
                    return <li {...props} key={option.value}>{option.key}</li>;
                  }}
                  filterOptions={(options, state) => {
                    const filtered = options.filter((option) =>
                      option.key.toLowerCase().includes(state.inputValue.toLowerCase())
                    );
                    return [
                      { key: 'Add option', value: 'add-option', isAddOption: true },
                      ...filtered
                    ];
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" label="Select Category" />
                  )}
                  selectOnFocus
                  handleHomeEndKeys
                  clearOnEscape={false}
                  clearOnBlur={false}
                  disablePortal={true}
                  id="combo-box-demo"
                  onInputChange={handleCategoryInputChange}
                  noOptionsText={
                    <p onClick={openCategoryPopup} className="fs-6 fw-bold text-left sync-icon m-0 py-1 px-0">
                      {categoryName && categoryName.toString().trim() ? `Add "${categoryName}"` : "Add Category"}
                    </p>
                  }
                  />
                </div>
              )}

            <div className="col-12 d-flex mt-3">
              <Button onClick={saveHandler} className="ms-auto me-3 secondarybtn">SAVE</Button>
              <Button onClick={closeDialog} className="secondarybtn cancelbtn me-auto">CANCEL</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Duplicate Template Dialog */}
      <DuplicateTemplateDialog
        open={duplicateDialog.open}
        templateName={duplicateDialog.templateName}
        existingTemplateId={duplicateDialog.existingTemplateId}
        dialogClose={closeDuplicateDialog}
        canProceed={duplicateDialog.canProceed}
        itemsEqual={duplicateDialog.itemsEqual}
      />
    </>
  );
}

export default SaveTemplate;
